import { Button, Popover, Typography } from "@mui/material"
import { useState } from "react";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Link } from "react-router-dom";
import { dogUrlGenerator } from "../../util.js/dogUrlGenerator";


export const EditPopup = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div>
            <Button aria-describedby={id} variant="standard" onClick={handleClick}>
                <MoreHorizIcon />
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div className="py-2 px-4">
                    <Link to={`/dog_registrations/edit/${props.dog_id}`}>
                        Edit
                    </Link>
                </div>

            </Popover>
        </div>
    )
}